import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { setStatusFail } from "../statusFail/statusFailSlice";

const initialState = {
  users: [],
  singleUser: null,
  createProfileStatus: "idle",  
  getProfilesStatus: "idle",
  getSingleProfileStatus: "idle",
  editProfileStatus: "idle",
  patients:[],
  error: null,
  totalPages: 0,
  isLoading:false
};
// if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
//         const route = "/status-failed"
//         await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
//       }
//       return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL;

export const createProfile = createAsyncThunk(
  "users/createProfile",
  async ({ updatedFormData: body }, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.post(`${ACCOUNTS_URL}/profiles/practioner-profile`,
        body,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
     if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || error.response?.data?.message || "Something went wrong");
    }
  }
);

export const getProfiles = createAsyncThunk(
  "users/getProfiles",
 
  async ({ currentPage, sortBy, order, itemsPerPage,userType }, { rejectWithValue,dispatch }) => {
 
    try {
      const response = await axios.get(`${ACCOUNTS_URL}/profiles`, {
        params: { page: currentPage, limit: itemsPerPage, sortBy, order },

        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
          tenantId: Cookies.get("TenantId"),
          userType
 
        },
      });
     
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

export const getSingleProfile = createAsyncThunk(
  "users/getSingleProfile",
  async (id, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ACCOUNTS_URL}/profiles/${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

export const editProfile = createAsyncThunk(
  "users/editProfile",
  async ({ body, id, userId }, { rejectWithValue,dispatch }) => {
     
    try {
      const response = await axios.patch(`${ACCOUNTS_URL}/profiles/${id}/${userId}`, body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("Token")}`
        }
      });
       
      return { id, profile: response.data.data };
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

export const editProfileStatus = createAsyncThunk(
  "users/editProfile",
  async ({ body, id, userId }, { rejectWithValue,dispatch }) => {
    const tenantId =  Cookies.get("TenantId")
    try {
      const response = await axios.patch(
        `${ACCOUNTS_URL}/profiles/update-profile-status/${id}/${tenantId}/practitioner`,
        body,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
       
      return { id, profile: response.data.data };
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers:{
    clearError: (state) => {
      state.error = null
    },
    clearUsersError:(state)=>{
      state.error = null;
    },
    clearSingleUser:(state)=>{
      state.singleUser = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createProfile.fulfilled, (state, action) => {
        state.isLoading =false ;
        state.users.push(action.payload);
        state.singleUser = action.payload;
      })
      .addCase(createProfile.rejected, (state, action) => {
        state.isLoading = false ;
        state.error = action.payload;
      })
      .addCase(getProfiles.pending, (state) => {
        state.isLoading = true
        state.error =  null
      })
      .addCase(getProfiles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload.profiles;
        state.totalPages = action.payload.totalPages;
        state.error = null;
      })
      .addCase(getProfiles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getSingleProfile.pending, (state) => {
        state.getSingleProfileStatus = "loading";
        state.error =  null
      })
      .addCase(getSingleProfile.fulfilled, (state, action) => {
        state.getSingleProfileStatus = "succeeded";
        state.singleUser = action.payload;
        state.error = null;
      })
      .addCase(getSingleProfile.rejected, (state, action) => {
        state.getSingleProfileStatus = "failed";
        state.error = action.payload;
      })
      .addCase(editProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(editProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        const filteredData = state.users.map((elm) =>
          elm._id === action.payload.id ? action.payload.profile : elm
        );
        state.users = filteredData;
       
      })
      .addCase(editProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const {clearError,clearUsersError,clearSingleUser} = usersSlice.actions

export default usersSlice.reducer;
